import { FooterLink, FooterLinkProps } from './footer-link';

interface LinksListProps {
  title?: string;
  items: FooterLinkProps[];
}

export const LinksList = ({ title, items }: LinksListProps) => {
  return (
    <div
      className='min-w-36 lg:min-w-0 sm:max-w-[210px] text-start'
    >
      {title && (
        <h4 className="text-lg font-medium text-cool-gray-700 mb-5">{title}</h4>
      )}
      <ul className="flex flex-col gap-4">
        {items.map(({ href, name }) => (
          <li className='leading-6 ' key={name}>
            <FooterLink name={name} href={href} />
          </li>
        ))}
      </ul>
    </div>
  );
};